import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  pageTitle: "Shortlink Admin"
};

const headerSlice = createSlice({
  name: 'header',
  initialState,
  reducers: {
    setHeader: (state, action) => {
      return {
        pageTitle: action.payload
      };
    },
  }
});

const { actions, reducer } = headerSlice;
export const { setHeader } = actions;
export default reducer;
